// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"kSsBs":[function(require,module,exports,__globalThis) {
var _jsxRuntime = require("react/jsx-runtime");
var _client = require("react-dom/client");
var _tokenList = require("./token_list");
window.onload = async ()=>{
    const container = document.getElementById("token-list");
    const root = (0, _client.createRoot)(container);
    root.render(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tokenList.TokenPage), {}));
};

},{"react/jsx-runtime":"dpQXr","react-dom/client":"i3gF3","./token_list":"2hCBB"}],"2hCBB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TokenPage", ()=>TokenPage);
var _jsxRuntime = require("react/jsx-runtime");
var _luxon = require("luxon");
var _react = require("react");
var _commonUtils = require("../../../../common/common_utils");
var _controlledTooltip = require("../../dashboard/forms/improved_components/tooltips/controlled_tooltip");
var _markdown = require("../../dashboard/markdown_parser/markdown");
function selectText(element_id) {
    const doc = document;
    const text = doc.getElementById(element_id);
    //all others
    const selection = window.getSelection();
    const range = doc.createRange();
    range.selectNodeContents(text);
    selection.removeAllRanges();
    selection.addRange(range);
}
function getTokens(filter) {
    const tokens = Object.keys((0, _commonUtils.common_utils).PlaceholderTokens).filter(filter);
    return tokens;
}
function TokenPage() {
    // christmas!
    const date = (0, _luxon.DateTime).fromObject({
        year: (0, _luxon.DateTime).now().year,
        month: 12,
        day: 31,
        hour: 20,
        minute: 0
    }, {
        zone: "America/New_York"
    });
    const context = {
        event_name: "New Years Party",
        event_link: undefined,
        start_time: date,
        timezone: "America/New_York",
        duration_ms: date.diffNow().toMillis(),
        description: "Watch the ball drop!",
        rsvp_options: [
            {
                name: "Yes",
                emoji: "\u2705",
                has_reminders: false,
                user_ids: [
                    "1",
                    "2",
                    "3",
                    "4",
                    "5",
                    "6",
                    "7",
                    "8",
                    "9",
                    "10"
                ]
            },
            {
                name: "Maybe",
                emoji: "\u2753",
                has_reminders: false,
                user_ids: [
                    "123",
                    "456",
                    "789",
                    "4"
                ]
            },
            {
                name: "No",
                emoji: "\u274C",
                has_reminders: false,
                user_ids: [
                    "123",
                    "456",
                    "789"
                ]
            }
        ]
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col gap-8",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(TokenList, {
                title: "Basic Placeholders",
                context: context,
                tokens: [
                    "$EventName",
                    "$EventDescription",
                    "$EventLink",
                    "$EventRSVPCounts"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(TokenList, {
                title: "Server DateTime Placeholders",
                description: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                    children: "Server datetime placeholders are dates which are displayed using the server's timezone."
                }),
                context: context,
                tokens: getTokens((val)=>val.startsWith("$DT_"))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(TokenList, {
                title: "Local DateTime Placeholders",
                description: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        "Local datetime placeholders use Discord Timestamps to generate date text that is displayed in",
                        " ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "italic",
                            children: "each user's local timezone"
                        }),
                        ". These are only supported in embed description fields. For more information, see",
                        " ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            className: "manual-link",
                            href: "https://sesh.fyi/timestamp/",
                            children: "here"
                        }),
                        ".",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        "The following placeholders are automatically converted to your local timezone (",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "command-example--inline",
                            children: Intl.DateTimeFormat().resolvedOptions().timeZone
                        }),
                        "), the same as they would be in Discord."
                    ]
                }),
                context: context,
                tokens: getTokens((val)=>val.startsWith("$TS_"))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Examples, {
                context: context,
                examples: [
                    "$EventName on $DT_DateMDY at $DT_Time $DT_TimezoneShort",
                    "$EventName $TS_Relative",
                    "Last day of $DT_YearNum!",
                    "$EventName: $DT_Weekday night!"
                ]
            })
        ]
    });
}
function TokenList(props) {
    const { tokens, context } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col gap-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "text-xl font-semibold",
                        children: props.title
                    }),
                    props.description && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: props.description
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "grid grid-cols-[auto_1fr] gap-x-4 gap-y-1",
                children: tokens.map((val)=>{
                    let secondary_element = val !== "$EventLink" ? (0, _markdown.parseAllowLinks)((0, _commonUtils.common_utils).PlaceholderTokens[val].transformer(context)) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "",
                        children: `{Link to Signup Message}`
                    });
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Token, {
                                token: val
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                children: secondary_element
                            })
                        ]
                    }, val);
                })
            })
        ]
    });
}
function Token(props) {
    const [tooltip_enabled, setTooltipEnabled] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _controlledTooltip.WithControlledTooltip), {
        tooltip: "copied!",
        style: "Info",
        disabled: !tooltip_enabled,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            id: props.token,
            className: "command-example--inline w-fit",
            onClick: ()=>{
                navigator.clipboard.writeText(props.token);
                setTooltipEnabled(true);
                setTimeout(()=>{
                    setTooltipEnabled(false);
                }, 1000);
                selectText(props.token);
            },
            children: props.token
        })
    });
}
function Examples(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col gap-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "text-xl font-semibold",
                children: "Examples"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex w-full flex-col items-center gap-1",
                children: props.examples.map((val, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex w-full flex-col items-center  justify-center  gap-2 rounded-sm bg-command p-4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "command-example--inline w-fit",
                                children: (0, _markdown.parseAllowLinks)(val)
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                className: "fas fa-arrow-down"
                            }, index),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "",
                                children: (0, _markdown.parseAllowLinks)((0, _commonUtils.common_utils).replacePlaceholders("EmbedDescription", val, props.context))
                            })
                        ]
                    }, index))
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","luxon":"fLWpi","react":"IMRgT","../../../../common/common_utils":"gACUC","../../dashboard/forms/improved_components/tooltips/controlled_tooltip":"bumzg","../../dashboard/markdown_parser/markdown":"gk0Ee","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"bumzg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WithControlledTooltip", ()=>WithControlledTooltip);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _withTooltip = require("./with_tooltip");
const clamp = (num, min, max)=>Math.min(Math.max(num, min), max);
function WithControlledTooltip(props) {
    const [tooltip_x, setTooltipX] = (0, _react.useState)(0);
    const [arrow_x, setArrowX] = (0, _react.useState)(0);
    const windowSize = (0, _withTooltip.useWindowSize)();
    const tooltip_ref = (0, _react.useRef)(null);
    const parent_ref = (0, _react.useRef)(null);
    const arrow_ref = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        if (!tooltip_ref?.current || !parent_ref?.current || !windowSize || !arrow_ref?.current || !windowSize.width) return;
        const { width: t_width } = tooltip_ref.current.getBoundingClientRect();
        const { left: p_left, width: p_width } = parent_ref.current.getBoundingClientRect();
        // Hack to determine border length, since can't set child relative to border
        const border_offset = getComputedStyle(tooltip_ref.current).borderLeftWidth;
        const border_thickness = Number.parseInt(border_offset.substring(0, border_offset.length - 2));
        const { width: a_width } = arrow_ref.current.getBoundingClientRect();
        const desired_absolute_tooltip_x = p_left + p_width / 2 - t_width / 2;
        const absolute_tooltip_x = clamp(desired_absolute_tooltip_x, 0, windowSize.width - t_width);
        const relative_tooltip_x = absolute_tooltip_x - p_left;
        setTooltipX(relative_tooltip_x);
        const desired_absolute_arrow_x = p_left + p_width / 2 - a_width / 2;
        const absolute_arrow_x = clamp(desired_absolute_arrow_x, absolute_tooltip_x, absolute_tooltip_x + t_width);
        const relative_arrow_x = absolute_arrow_x - absolute_tooltip_x;
        // it is one pixel off for some reason
        setArrowX(-border_thickness + relative_arrow_x + 1);
    }, [
        tooltip_ref,
        parent_ref,
        arrow_ref,
        windowSize,
        props.disabled
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "dropdown inline-flex w-fit max-w-full items-center",
        ref: parent_ref,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "dropdown-trigger max-w-full flex-grow",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "max-w-full flex-grow cursor-pointer",
                    "aria-haspopup": "true",
                    "aria-controls": "dropdown-menu4",
                    children: props.children
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                style: {
                    left: tooltip_x
                },
                className: (0, _classnamesDefault.default)("has-text-centered absolute z-20 mb-2 flex h-max w-max max-w-[15rem] overflow-auto rounded-sm p-2 text-xs font-semibold drop-shadow-xl transition-opacity sm:max-h-[24rem] sm:max-w-[24rem] sm:!p-3 sm:text-sm", {
                    "tooltip-v2": props.style === "Info",
                    "tooltip-v2--error": props.style === "Error",
                    hidden: props.disabled
                }),
                id: "dropdown-menu4",
                role: "menu",
                ref: tooltip_ref,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "pointer-events-none overflow-auto",
                        children: props.tooltip
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "tooltip-arrow",
                        ref: arrow_ref,
                        style: {
                            left: arrow_x
                        }
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","react":"IMRgT","./with_tooltip":"bOdAf","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"kMaoF":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"eIHvQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TIMESTAMP_TYPES", ()=>TIMESTAMP_TYPES);
var _luxon = require("luxon");
const TIMESTAMP_TYPES = {
    F: (d)=>d.toLocaleString({
            month: "long",
            weekday: "long",
            day: "2-digit",
            year: "numeric",
            hour: "numeric",
            minute: "numeric"
        }),
    f: (d)=>d.toLocaleString({
            month: "long",
            year: "numeric",
            day: "2-digit",
            hour: "numeric",
            minute: "numeric"
        }),
    D: (d)=>d.toLocaleString({
            month: "long",
            day: "2-digit",
            year: "numeric"
        }),
    d: (d)=>d.toLocaleString({
            month: "2-digit",
            day: "2-digit",
            year: "numeric"
        }),
    t: (d)=>d.toLocaleString({
            hour: "numeric",
            minute: "numeric"
        }),
    T: (d)=>d.toLocaleString((0, _luxon.DateTime).TIME_WITH_SECONDS),
    R: (d)=>d.toRelative({}),
    s: (d)=>d.toLocaleString({
            month: "2-digit",
            day: "2-digit",
            year: "numeric",
            hour: "numeric",
            minute: "numeric"
        }),
    S: (d)=>d.toLocaleString({
            month: "2-digit",
            day: "2-digit",
            year: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric"
        })
};

},{"luxon":"fLWpi","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}]},["kSsBs"], "kSsBs", "parcelRequire7ff5", {})

//# sourceMappingURL=placeholders.d4a2055f.js.map
